<template>
  <div class="forgot-password-page">
    <img class="layout__q-logo" src="/images/logo-small.svg" />
    <div class="forgot-password-page-login">
      <div class="forgot-password-page-login__logo">
          <img
            class="forgot-password-page-login__logo__img"
            :src="`/images/logo.svg`"
            alt="OWQLO"
          />
      </div>
      <app-i18n class="forgot-password-page-login__title" code="auth.passwordResetEmail.message" />

      <div class="forgot-password-page-login__title-separator" />
      <el-form
        :model="model"
        :rules="rules"
        @submit.prevent.native="doSubmit"
          @keypress.enter.native="doSubmit"
        class="forgot-password-page-login__form"
        ref="form"
        v-if="model"
      >
        <el-row>
          <!-- Email -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item :prop="fields.email.name">
              <el-input
                :placeholder="i18n('auth.fields.email')"
                prefix-icon="icon-mail"
                auto-complete="off"
                ref="focus"
                v-model="model[fields.email.name]"
              />
            </el-form-item>
          </el-col>

          <!-- Reset button -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item class="forgot-password-page-login__form__button">
              <el-button :loading="loading" @click="doSubmit" type="primary">
                <app-i18n code="auth.passwordResetEmail.message" />
              </el-button>
            </el-form-item>
          </el-col>

          <!-- Cancel -->
          <el-col :lg="24" :md="24" :sm="24">
            <el-form-item class="forgot-password-page-login__form__cancel">
              <div class="forgot-password-page-login__form__cancel__wrapper">
                <router-link :to="{ path: '/auth/signin' }">
                  <app-i18n class="forgot-password-page-login__form__cancel__link" code="common.cancel" />
                </router-link>
              </div>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { UserModel } from '@modules/auth/user-model';
import { i18n } from '@shared/i18n';

export default {
  name: 'app-forgot-password-page',

  data() {
    return {
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      loading: 'auth/loadingPasswordResetEmail',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),
    rules() {
      const { fields } = this;
      return {
        email: fields.email.forFormRules(),
      }
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new UserModel({
        dateFormat, timeFormat
      }).fields();
    },

    originUrl() {
      return window.location.href
    }
  },

  methods: {
    ...mapActions({
      doSendPasswordResetEmail:
        'auth/doSendPasswordResetEmail',
    }),

    async doSubmit($event) {
      if ($event) $event.preventDefault()

      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      await this.doSendPasswordResetEmail({ email: this.model.email, originUrl: this.originUrl });
    },
    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style lang="scss" scoped>

.forgot-password-page .layout__q-logo {
  width: 800px;
}

.forgot-password-page-login {
  @include auth-mixin;

  background-color: white;
  position: absolute;
  width: 754px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
  padding: 6em 0 3em 0;

  &__form {
    width: 350px;

    &__cancel {
      &__link {
        margin-left: 5px;
        color: #2acccc;
        font-weight: bold;
      }
    }
    &__button {
      margin-top: 20px;
    }

    @include mobile {
      width: 300px;
    }
  }
  @include small-mobile {
    padding-top: 6em;
  }
  @include mobile {
    width: 100vw;
    height: 100vh;
    display: grid;
    align-content: center;
  }
}
</style>
